module.exports = __webpack_public_path__ + "img/storage.d9fdbd39.png";